var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"VueTables__list-filter pt-2",attrs:{"id":("VueTables__" + (_vm.props.column) + "-filter")}},[_c('v-select',{ref:"",staticClass:"font-weight-regular",class:_vm.props.theme.select,staticStyle:{"max-width":"150px"},attrs:{"dense":"","name":_vm.props.name,"value":_vm.props.value,"items":[
      { value: '', text: _vm.props.defaultOption } ].concat( _vm.props.items.map(function (option) { return ({
        value: option.id,
        text: option.text
      }); })
    )},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }